
import React from 'react';
import MainLayout from '../../../layouts/MainLayout';
import '../styles/Thinkletics.css';

const AboutCommerceletics = () => {
    return (
        <MainLayout>
            <div>
                <h3 className='text-lg mt-1 mx-8 border-b border-b-gray-300 text-white'>Commerceletics</h3>
            </div>
            <div className="main-content text-white ml-4 mr-4">
                <header>
                    <h1 className="h1 bg-yellow-500 text-white text-center">Commerceletics: The International Competition</h1>
                    <p className="text-xl text-yellow-300 text-center">For everybody from Students to Scientists, Workers to CEOs who are Deep Thinkers & Intellectual</p>
                    <p className="mt-4 text-2xl  bg-purple-500 text-white text-center"><strong>Commerceletics@Think5Whys – where deep thinkers become intellectual.</strong></p>
                </header>

                <section className="section">
                    <h2 className="h2">Welcome</h2>
                    <p>Welcome to Commerceletics, where the world's sharpest minds converge for a unique blend of deep thinking and competitive challenges.</p>
                </section>

                <section className="section">
                    <h2 className="h2">About the Competition</h2>
                    <p>This annual international competition celebrates intellectual prowess and mental agility, fostering a spirit of innovation and excellence.</p>
                    <p>Join us in a series of thought-provoking activities designed to test and expand your cognitive abilities, and compete with like-minded people from around the globe.</p>
                    <p><strong>Commerceletics is an Annual Competition</strong></p>
                </section>

                <section className="section">
                    <h2 className="h2">Rewards</h2>
                    <p>Winner, first runner up & second runner up will get cash rewards (direct transfer), medals & certificates (eCertificates) both will be delivered to winners' addresses.</p>
                    <p>Top 1% of participants qualified for Commerceletics will be awarded with Commerceletics: IMDeepThinker eCertificate.</p>
                    <p>All participants qualified for Commerceletics will be awarded with Commerceletics Participants eCertificate.</p>
                </section>

                <section className="section">
                    <h2 className="h2">Event Categories</h2>
                    <h3 className="h3">Open Event - Country or Region Specific</h3>
                    <p>Examples:</p>
                    <ul className="ul">
                        <li>International Commerceletics</li>
                        <li>Indian Commerceletics</li>
                        <li>Dubai Commerceletics</li>
                        <li>GCC Commerceletics</li>
                        <li>European Commerceletics</li>
                        <li>Asia-Pacific Commerceletics</li>
                        <li>Maharashtra Commerceletics</li>
                    </ul>
                    <h3 className="h3">Institutional / Sponsored Event - Company Specific</h3>
                    <p>Examples:</p>
                    <ul className="ul">
                        <li>Reliance Commerceletics</li>
                        <li>HDFC Commerceletics</li>
                        <li>Maharashtra Government Commerceletics</li>
                        <li>Nepal Government Commerceletics</li>
                        <li>DPS Commerceletics</li>
                    </ul>
                </section>

                <section className="section">
                    <h2 className="h2">Participant Categories</h2>
                    <h3 className="h3">Open Categories</h3>
                    <ul className="ul">
                        <li>School</li>
                        <li>Undergraduate</li>
                        <li>Post Graduate</li>
                    </ul>
                    <h3 className="h3">Institutional / Sponsored Categories</h3>
                    <ul className="ul">
                        <li>Worker</li>
                        <li>Executives</li>
                        <li>Managers</li>
                    </ul>
                </section>

                <section className="section">
                    <h2 className="h2">Event Types</h2>
                    <ul className="ul">
                        <li>Open Event</li>
                        <li>Institutional Event</li>
                        <li>Institution ID</li>
                    </ul>
                </section>

                <section className="section">
                    <h2 className="h2">How to Earn Points?</h2>
                    <ol className="ol">
                        <li>Enrollment: 10</li>
                        <li>Think5Whys Collection 1 Purchase: 20</li>
                        <li>Compulsory Online Assignment: 30</li>
                        <li>Each MCQ Set Practice (Max 5): 5</li>
                        <li>Certification Test: 50</li>
                        <li>Event Registration: 10</li>
                        <li>Each Think5whys RCA Data Entry: 5</li>
                        <li>Each Think5Whys Life Chronicles Data Entry: 5</li>
                        <li>Each RCA & Life Chronicle Linking: 5</li>
                        <li>Think5Whys Book Every Unique Page Read: 1</li>
                        <li>Each SpotSnap Entry: 5</li>
                        <li>Each Focus Timer 25 minutes Pomodoro: 2</li>
                    </ol>
                </section>
            </div>
        </MainLayout>
    );
};

export default AboutCommerceletics;
